import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { List } from 'immutable'
import Button, { TYPES } from '../../Button/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { getHelpCenterUrl } from '../../../services/url/index'
import { getPrimary } from '../../../services/languages/index'

const ChatBlockedUser = (props) => {
  const { staticText, userLanguage } = props
  const userPrimaryLanguage = getPrimary(userLanguage)
  return (
    <div className="chat__blocked">
      {staticText.getIn(['data', 'blockedFromChatText'])}
      <Button
        type={TYPES.PRIMARY}
        url={getHelpCenterUrl(userPrimaryLanguage)}
      >
        {staticText.getIn(['data', 'helpCenter'])}
      </Button>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'eventsPage' }),
  connectRedux(
    (state) => ({
      userLanguage: state.user.getIn(['data', 'language'], List()),
    }),
  ),
)(ChatBlockedUser)
